
import { AlertCircle } from 'lucide-react';

interface ErrorDisplayProps {
  error: string;
}

const ErrorDisplay = ({ error }: ErrorDisplayProps) => {
  if (!error) return null;
  
  return (
    <div className="mb-6 p-3 bg-red-50 text-red-700 rounded-lg flex items-center">
      <AlertCircle className="h-5 w-5 mr-2 flex-shrink-0" />
      <p className="text-sm">{error}</p>
    </div>
  );
};

export default ErrorDisplay;
